import { render, staticRenderFns } from "./TransfereCards.vue?vue&type=template&id=09cd3a71"
import script from "./TransfereCards.vue?vue&type=script&lang=js"
export * from "./TransfereCards.vue?vue&type=script&lang=js"
import style0 from "./TransfereCards.vue?vue&type=style&index=0&id=09cd3a71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports